/**
 * ResponsivePackerView.tsx
 *
 * Wrapper that shows bare MobilePackerView on mobile (< 768px) and
 * MobilePackerView embedded inside Layout on desktop (>= 768px).
 * On desktop, the Layout sidebar/header is used and the mobile amber header
 * and slide-out sidebar are hidden.
 */
import React, { useState, useEffect } from 'react';
import Layout from './Layout';
import MobilePackerView from '../pages/Mobile/MobilePackerView';

const MOBILE_BREAKPOINT = 768;

const ResponsivePackerView: React.FC = () => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) {
    return <MobilePackerView />;
  }

  return (
    <Layout>
      <MobilePackerView embedded />
    </Layout>
  );
};

export default ResponsivePackerView;
